export default "__VITE_ASSET__BD8GBXKt__"